import React from "react";
import { PieChart } from "react-minimal-pie-chart";

function DeviceHealthChart({ chartData }) {
    return (
        <div className="col-12 text-center">
            <PieChart data={chartData} style={{ height: "200px" }} />
        </div>
    );
}

export default DeviceHealthChart;
